import React, { useCallback, useEffect } from 'react'
import { Spin, Typography } from 'antd'
import { isEmpty } from 'lodash'

import { showErrorNotification } from '../../../core/helpers'

import { Page } from '../../../common/components/sections'
import {
  StyledPageTitle,
  StyledTaskPageHeader,
} from '../../../common/components/styled'
import { APP_ROUTES } from '../../../common/constants'
import { useDocumentTitle } from '../../../common/hooks'

import { useStartTargetedDbFlashMutation } from '../../hooks'
import { TargetedDbFlashForm } from '../forms'

const TargetedDbFlashPage = () => {
  useDocumentTitle(APP_ROUTES.MISC.children.TARGETED_DB_FLASH.label)

  const [startTargetedDbFlash, { isLoading, error, data }] =
    useStartTargetedDbFlashMutation()

  useEffect(() => {
    if (error) {
      showErrorNotification({
        title: 'Failed to start db flash success',
        description: error,
      })
    }
  }, [error])

  const handleSubmit = useCallback(
    formData => startTargetedDbFlash(formData.dishTypeIds),
    [startTargetedDbFlash],
  )

  if (isLoading) {
    return <Spin />
  }

  return (
    <Page>
      <StyledTaskPageHeader sticky>
        <StyledPageTitle>Targeted DB flash</StyledPageTitle>
      </StyledTaskPageHeader>
      <TargetedDbFlashForm onSubmit={handleSubmit} />
      {!isEmpty(data) && (
        <div>
          <Typography.Paragraph>
            Included dish count in db flash:{' '}
            <Typography.Text strong>
              {data?.includedDishCountInDbFlash}
            </Typography.Text>
          </Typography.Paragraph>
          <Typography.Paragraph>
            Included menu curation task count in db flash:{' '}
            <Typography.Text strong>
              {data?.includedMenuCurationTaskCountInDbFlash}
            </Typography.Text>
          </Typography.Paragraph>
        </div>
      )}
    </Page>
  )
}

export default TargetedDbFlashPage
